import { useEffect } from 'react';
/**
 * This component applies a fix in the integration site for iframes
 * for the issue on mobile IOS regarding iframe sizing.
 * @see https://blog.codepen.io/2017/12/01/stupid-iframes-stupid-ios/
 */
export const IframeIosMobileFix = () => {
    useEffect(() => {
        if (window === top) {
            return;
        }
        const html = document.querySelector('html');
        const body = document.querySelector('body');
        html.style.height = '100%';
        html.style.overflow = 'hidden';
        body.style.height = '100%';
        body.style.overflow = 'auto';
        body.style['-webkit-overflow-scrolling'] = 'touch';
    }, []);
    return null;
};
//# sourceMappingURL=IframeIosMobileFixComponent.js.map